import { findClosestValueIndex, roundValueToStep } from '../../helpers';
export function useSliderHelpers(_ref) {
  var props = _ref.props,
    marks = _ref.marks;
  var step = props.step,
    min = props.min;
  var roundValue = function roundValue(value) {
    if (step) {
      return roundValueToStep(value, step, min);
    }
    var marksValues = marks.map(function (mark) {
      return mark.value;
    });
    var closestIndex = findClosestValueIndex(marksValues, value);
    return marksValues[closestIndex];
  };
  return {
    roundValue: roundValue
  };
}